import { defineAsyncComponent } from 'vue'
import { SubmissionPageName } from 'store/submission-store'
import ReviewForm from 'components/review-form/ReviewForm.vue'
import AddVideo from 'components/review-form/visual/AddVideo.vue'


const submissionPageComponents: { [key in SubmissionPageName]: unknown } = {
  'add-captions': defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'add-captions' */ 'components/review-form/visual/AddCaptions.vue')
  ),
  // TODO: failing when async loaded.  May be related to ReviewForm issue
  'add-video':  AddVideo,
  // 'add-video':  () => defineAsyncComponent(
  // eslint-disable-next-line
  //   () => import(/* webpackChunkName: 'add-video' */ 'components/review-form/visual/AddVideo.vue')
  // ),
  'do-more':  defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'do-more' */ 'components/do-more/DoMore.vue')
  ),
  registration:  defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'registration' */ 'components/registration/Registration.vue')
  ),
  // TODO: Use non-async ReviewForm for until Vue keep-alive bug us fixed
  // https://github.com/vuejs/vue-next/issues/3529
  'review-form': ReviewForm,
  // 'review-form':  defineAsyncComponent(
  // eslint-disable-next-line
  //   () => import(/* webpackChunkName: 'review-form' */ 'components/review-form/ReviewForm.vue')
  // ),
  'seller-rating-form':  defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'seller-ratings' */ 'components/seller-ratings/SellerRatingForm.vue')
  ),
  'share-media':  defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'share-media' */ 'components/review-form/visual/ShareMedia.vue')
  ),
  'solo-question':  defineAsyncComponent(
    // eslint-disable-next-line
    () => import(/* webpackChunkName: 'solo-question' */ 'components/question/SoloQuestion.vue')
  )
}

export default submissionPageComponents
